"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noteSchema = exports.noteInputSchema = exports.NOTE_MAX = exports.noteParamsSchema = void 0;
// The note a nurse writes on a workup (`J-473`).
//
// FREE TEXT, AND THAT IS THE WHOLE CONTRACT. `.claude/rules/notes-are-free-text.md` is the project
// owner's standing rule of 2026-09-23: `RPM-047`'s structured note, `RPM-048`'s SBAR form and
// `RPM-049`'s derived action sentence are not built, and nothing here has sections, headings, a
// template, a required field inside the text, or a derivation of any kind. A body with anything
// beyond the text is refused by the strict object, which is what stops a structure arriving one
// optional field at a time.
//
// IT GATES NOTHING. The note is not a gate code, not an obligation, and not a precondition of any
// save. A workup with no note is a complete workup, and a `GET` on one answers `null` rather than a
// refusal.
//
// EDITABLE, LAST WRITE WINS, which the project owner asked for in those words. There is no version
// history and no append-only trail: `rpm_alert_state_transitions` is for state, and a note is not a
// transition. The two stamps are what a later reader has — who wrote what stands, and when.
const zod_1 = require("zod");
exports.noteParamsSchema = zod_1.z.strictObject({ alertId: zod_1.z.uuid() });
/**
 * The longest note the column takes.
 *
 * `note_text` is `text` and PostgreSQL does not bound it, so the bound is the contract's. 4000 is
 * wide enough for anything a nurse types into a box on a screen and narrow enough that a client
 * cannot post a megabyte into a clinical record by accident. It is not a clinical rule and it is not
 * a structure: it is the size of the box.
 */
exports.NOTE_MAX = 4000;
exports.noteInputSchema = zod_1.z
    .strictObject({
    /**
     * What she wrote. The empty string is how a note is CLEARED, which is why the minimum is 0 and
     * not 1 — a nurse who decides the note was wrong must be able to take it back, and refusing an
     * empty body would leave her editing text she wants gone. The service turns it into `null`.
     */
    text: zod_1.z.string().max(exports.NOTE_MAX),
})
    .meta({ description: "The note, as she typed it" });
exports.noteSchema = zod_1.z
    .strictObject({
    rpmAlertId: zod_1.z.uuid(),
    /** Null where no note was ever written, and null again after one is cleared. */
    text: zod_1.z.string().nullable(),
    updatedAt: zod_1.z.iso.datetime().nullable(),
    /**
     * The account that wrote what stands, by the name it signs in under.
     *
     * A NAME AND NOT A UUID, because the line under the box is read by a nurse. It comes from Better
     * Auth's `user` row — `user.name`, falling back to `user.email` — and never from `people`:
     * `findPeopleReadsInHandlers` (`packages/schema/src/people-joins.ts:131`) refuses a clinical-path
     * handler reading a person, and an account is not a person here (nothing links the two).
     */
    updatedByName: zod_1.z.string().nullable(),
})
    .meta({ id: "WorkupNote", description: "The note on a workup, and who last wrote it" });
//# sourceMappingURL=rpm-note.js.map